import { render, staticRenderFns } from "./RequestTab.vue?vue&type=template&id=2e4fc30e&scoped=true"
import script from "./RequestTab.vue?vue&type=script&lang=js"
export * from "./RequestTab.vue?vue&type=script&lang=js"
import style0 from "./RequestTab.vue?vue&type=style&index=0&id=2e4fc30e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4fc30e",
  null
  
)

export default component.exports